/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type CreatedCustomerPromptRequest = {
    /**
     * * `RATING_5L` - RATING_5L
     * * `RATING_5N` - RATING_5N
     * * `SINGLE_SEL` - SINGLE_SEL
     * * `MULTI_SEL` - MULTI_SEL
     * * `OPEN_END` - OPEN_END
     * * `MATRIX_N` - MATRIX_N
     * * `MATRIX_L` - MATRIX_L
     * * `NPS` - NPS
     */
    type: CreatedCustomerPromptRequest.type;
    text: string;
    topicSlug?: string;
    polarity?: number;
    choiceLabels?: Array<string>;
};

export namespace CreatedCustomerPromptRequest {

    /**
     * * `RATING_5L` - RATING_5L
     * * `RATING_5N` - RATING_5N
     * * `SINGLE_SEL` - SINGLE_SEL
     * * `MULTI_SEL` - MULTI_SEL
     * * `OPEN_END` - OPEN_END
     * * `MATRIX_N` - MATRIX_N
     * * `MATRIX_L` - MATRIX_L
     * * `NPS` - NPS
     */
    export enum type {
        RATING_5L = 'RATING_5L',
        RATING_5N = 'RATING_5N',
        SINGLE_SEL = 'SINGLE_SEL',
        MULTI_SEL = 'MULTI_SEL',
        OPEN_END = 'OPEN_END',
        MATRIX_N = 'MATRIX_N',
        MATRIX_L = 'MATRIX_L',
        NPS = 'NPS',
    }


}

